import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { getProject } from '../../../../utils/utils';
import { useSelector } from 'react-redux';
import PropTypes from '../../../../utils/propTypes';

const ProtectedComponent = ({ roles }) => {
  const location = useLocation();
  const { me } = useSelector(({ auth }) => auth);
  const isProjectsPage = location.pathname.includes('projects');
  const isUsersPage = location.pathname.includes('users');
  const isEHECERoute =
    location.pathname.includes('/ce') || location.pathname.includes('/ehe');
  const isOCRRoute = location.pathname.includes('/ocr');
  const isAllowedByRole = roles && me?.role ? roles.includes(me?.role) : true;
  const { id } = useParams();
  const project = getProject(id);
  return (isProjectsPage ||
    isUsersPage ||
    project ||
    isEHECERoute ||
    isOCRRoute) &&
    isAllowedByRole ? (
    <Outlet context={{ project }} />
  ) : (
    <Navigate to="/login" />
  );
};

ProtectedComponent.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

ProtectedComponent.defaultProps = {
  roles: undefined,
  children: undefined,
};

export default ProtectedComponent;
